import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "I built a node app to thaw my favorite snack 🥕",
  "description": "",
  "published": "2018-10-11T00:00:00.000Z",
  "redirect_from": ["/blog/i-built-a-node-app-to-thaw-my-favorite-snack-🥕/swizec/8660"],
  "categories": "Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    {
      /* wp:paragraph */
    }
    <p>{`The office fridge hates me and keeps freezing my carrots. I love carrots. They're the perfect low calorie crunchy snack for those afternoons when you're chasing an errant semicolon for two hours and your code isn't working.`}</p>
    {
      /* /wp:paragraph */
    }
    {
      /* wp:paragraph */
    }
    <p>{`But they're not very tasty frozen. In fact they're disgusting when frozen.`}</p>
    {
      /* /wp:paragraph */
    }
    {
      /* wp:paragraph */
    }
    <p>{`You gotta thaw those suckers.`}</p>
    {
      /* /wp:paragraph */
    }
    {
      /* wp:paragraph */
    }
    <p>{`How do you thaw carrots at the office? With your laptop!`}</p>
    {
      /* /wp:paragraph */
    }
    {
      /* wp:paragraph {"className":"twitter-tweet"} */
    }
    <blockquote {...{
      "className": "twitter-tweet",
      "data-dnt": "true"
    }}><p parentName="blockquote" {...{
        "lang": "en",
        "dir": "ltr"
      }}>{`Is there a node package I can run to warmup my laptop? I’m thawing some carrots and it’s taking too long `}<a parentName="p" {...{
          "href": "https://t.co/AZiY0RanRf"
        }}>{`pic.twitter.com/AZiY0RanRf`}</a></p>{`— Swizec Teller published ServerlessHandbook.dev (@Swizec) `}<a parentName="blockquote" {...{
        "href": "https://twitter.com/Swizec/status/1050142413468000256"
      }}>{`October 10, 2018`}</a></blockquote>
    {
      /* /wp:paragraph */
    }
    {
      /* wp:paragraph */
    }
    <p>{`But sometimes that doesn't work. Maybe you're chasing that errant semicolon for so long that your computer cools down. Maybe webpack is actually fast for once. Maybe even VSCode and Chrome and XCode aren't doing the job.`}</p>
    {
      /* /wp:paragraph */
    }
    {
      /* wp:paragraph */
    }
    <p>{`Never thought I'd say this, but sometimes macs just don't wanna get hot no matter what you do.`}</p>
    {
      /* /wp:paragraph */
    }
    {
      /* wp:paragraph */
    }
    <p>{`So I built a tool! A node app. An app that thaws your carrots. Keeps your hands warm. In winter it might even heat your room.`}</p>
    {
      /* /wp:paragraph */
    }
    {
      /* wp:paragraph {"className":"twitter-tweet"} */
    }
    <blockquote {...{
      "className": "twitter-tweet",
      "data-dnt": "true"
    }}><p parentName="blockquote" {...{
        "lang": "en",
        "dir": "ltr"
      }}>{`Perhaps my most important contribution to our field 👇`}<br parentName="p"></br><br parentName="p"></br>{`🥕 thaw-carrots -t 90`}<br parentName="p"></br><br parentName="p"></br>{`Keep CPU at 90℃`}<br parentName="p"></br><br parentName="p"></br>{`👉 `}<a parentName="p" {...{
          "href": "https://t.co/qpA039OQ00"
        }}>{`https://t.co/qpA039OQ00`}</a><br parentName="p"></br><br parentName="p"></br>{`Never eat frozen snacks or have cold hands again. 🔥 `}<a parentName="p" {...{
          "href": "https://t.co/fnwJw7I8X5"
        }}>{`pic.twitter.com/fnwJw7I8X5`}</a></p>{`— Swizec Teller published ServerlessHandbook.dev (@Swizec) `}<a parentName="blockquote" {...{
        "href": "https://twitter.com/Swizec/status/1050288715178770432"
      }}>{`October 11, 2018`}</a></blockquote>
    {
      /* /wp:paragraph */
    }
    {
      /* wp:paragraph */
    }
    <p>{`The greatest contribution to computer science known to man! Or woman.`}</p>
    {
      /* /wp:paragraph */
    }
    {
      /* wp:paragraph */
    }
    <p>{`🥕 thaw-carrots -t 90`}</p>
    {
      /* /wp:paragraph */
    }
    {
      /* wp:paragraph */
    }
    <p>{`Install globally with npm or yarn – `}<inlineCode parentName="p">{`npm install -g thaw-carrots`}</inlineCode>{`, run with your favorite temperature, and `}<inlineCode parentName="p">{`thaw-carrots`}</inlineCode>{` will keep your CPU busy just enough to give you a nice even warm throughout your best carrot thawing areas.`}</p>
    {
      /* /wp:paragraph */
    }
    {
      /* wp:heading */
    }
    <h2 {...{
      "id": "heres-how-it-works-"
    }}>{`Here's how it works 👇`}</h2>
    {
      /* /wp:heading */
    }
    {
      /* wp:paragraph */
    }
    <p>{`With just 14 dependencies this might be the smallest node app you've ever seen. Thanks to `}<a parentName="p" {...{
        "href": "https://twitter.com/lukeed05"
      }}>{`@lukeed05`}</a>{` and his obsession with zero dependency code.`}</p>
    {
      /* /wp:paragraph */
    }
    {
      /* wp:paragraph */
    }
    <p><a parentName="p" {...{
        "href": "https://github.com/Swizec/thaw-carrots"
      }}>{`thaw-carrots`}</a>{` uses `}<a parentName="p" {...{
        "href": "https://github.com/lukeed/mri"
      }}>{`mri`}</a>{` to parse command line arguments, `}<a parentName="p" {...{
        "href": "https://github.com/lukeed/kleur"
      }}>{`kleur`}</a>{` and `}<a parentName="p" {...{
        "href": "https://github.com/freeall/single-line-log"
      }}>{`single-line-log`}</a>{` for pretty console output, and `}<a parentName="p" {...{
        "href": "https://github.com/sebhildebrandt/systeminformation"
      }}>{`systeminformation`}</a>{`to read CPU temperatures.`}</p>
    {
      /* /wp:paragraph */
    }
    {
      /* wp:paragraph */
    }
    <p>{`The approach is simple:`}</p>
    {
      /* /wp:paragraph */
    }
    {
      /* wp:list */
    }
    <ul>
      <li parentName="ul">{`run an infinite loop`}</li>
      <li parentName="ul">{`read temperature`}</li>
      <li parentName="ul">{`if temperature below target, add expensive background jobs`}</li>
      <li parentName="ul">{`if temperature above target, remove an expensive job`}</li>
      <li parentName="ul">{`print info`}</li>
      <li parentName="ul">{`repeat`}</li>
    </ul>
    {
      /* /wp:list */
    }
    {
      /* wp:paragraph */
    }
    <p>{`29 lines of code, 2 hours of tinkering`}</p>
    {
      /* /wp:paragraph */
    }
    {
      /* wp:code */
    }
    <pre><code parentName="pre" {...{}}>{`async function thawMyCarrots(targetTemp) {
    let temp = await readTemp(),
        temps = [temp, temp, temp],
        children = [];

    while (1) {
        if (avg(temps) < targetTemp) {
            if (children.length < 10) {
                children.push(fork(\`\${__dirname}/eat-cpu\`));
            }
        } else if (avg(temps) > targetTemp) {
            if (children.length > 0) {
                children.pop().kill();
            }
        }

        temp = await readTemp();
        temps.shift();
        temps.push(temp);

        sll(
            "Current temp",
            kleur.bold.red(temp.main.toFixed(2)),
            "\\nCores at",
            kleur.bold.gray(temp.cores),
            \`\\nChildren: \${children.length}\`
        );
        sleep.msleep(500);
    }
}
`}</code></pre>
    {
      /* /wp:code */
    }
    {
      /* wp:paragraph */
    }
    <p>{`We read the current CPU temperature, pre-fill our running tally of 3 measurements, and create an empty pool of children processes. Then start the loop.`}</p>
    {
      /* /wp:paragraph */
    }
    {
      /* wp:paragraph */
    }
    <p>{`The loop checks an average of the last 3 temperatures and decides what to do. If we have to warm up, we fork a new subprocess using the `}<inlineCode parentName="p">{`eat-cpu`}</inlineCode>{` file. If it's time to cool off, we kill one of the forks.`}</p>
    {
      /* /wp:paragraph */
    }
    {
      /* wp:paragraph */
    }
    <p>{`I kept max forks at 10 because that seemed reasonable.`}</p>
    {
      /* /wp:paragraph */
    }
    {
      /* wp:paragraph */
    }
    <p>{`Update our running array of temperature measurements, print current values to the screen, wait 500 milliseconds, do it all again. Perfect 👌`}</p>
    {
      /* /wp:paragraph */
    }
    {
      /* wp:heading */
    }
    <h2 {...{
      "id": "how-to-warm-a-cpu"
    }}>{`How to warm a CPU`}</h2>
    {
      /* /wp:heading */
    }
    {
      /* wp:paragraph */
    }
    <p>{`To warm a CPU, you have to make it work. Like an athlete at the gym, the CPU gets warm when it's working hard.`}</p>
    {
      /* /wp:paragraph */
    }
    {
      /* wp:paragraph */
    }
    <p>{`But what's hard for a CPU?`}</p>
    {
      /* /wp:paragraph */
    }
    {
      /* wp:paragraph */
    }
    <p>{`You want a process that's heavy on CPU and light on memory. Easy to spin up and down, make harder or easier. You want fine grained control over that temperature and you're fighting everything your OS was designed to prevent.`}</p>
    {
      /* /wp:paragraph */
    }
    {
      /* wp:paragraph */
    }
    <p>{`The low memory requirement disqualifies calculating primes, playing with big numbers, mining bitcoin, or running Slack. You'd be surprised how many people recommended I just run Slack or Chrome or Hangouts to thaw my carrots.`}</p>
    {
      /* /wp:paragraph */
    }
    {
      /* wp:paragraph */
    }
    <p>{`Those fools!`}</p>
    {
      /* /wp:paragraph */
    }
    {
      /* wp:paragraph */
    }
    <p>{`My first attempt was using the `}<a parentName="p" {...{
        "href": "https://en.wikipedia.org/wiki/Collatz_conjecture"
      }}>{`collatz conjecture`}</a>{`. Finite calculation, lots of addition and division and multiplication, handles big numbers okay, can run for a long time to find the full chain. No need to keep anything in memory while you're running.`}</p>
    {
      /* /wp:paragraph */
    }
    {
      /* wp:paragraph */
    }
    <p>{`But my CPU was too good at that. Didn't warm up for shit. And when the numbers got really high, Collatz fast became too slow to compute. Didn't have the fine grained control.`}</p>
    {
      /* /wp:paragraph */
    }
    {
      /* wp:paragraph */
    }
    <p>{`Then I found `}<a parentName="p" {...{
        "href": "https://gist.github.com/sqren/5083d73f184acae0c5b7"
      }}>{`this little gem from @sqren`}</a>{`. A gist called "cpu-intensive.js". Perfect!`}</p>
    {
      /* /wp:paragraph */
    }
    {
      /* wp:paragraph */
    }
    <p>{`Looks like this:`}</p>
    {
      /* /wp:paragraph */
    }
    {
      /* wp:code */
    }
    <pre><code parentName="pre" {...{}}>{`function mySlowFunction(baseNumber) {
    console.time('mySlowFunction');
    var result = 0;
    for (var i = Math.pow(baseNumber, 10); i >= 0; i--) {
        result += Math.atan(i) * Math.tan(i);
    };
    console.timeEnd('mySlowFunction');
    return result;
}

mySlowFunction(3);
`}</code></pre>
    {
      /* /wp:code */
    }
    {
      /* wp:paragraph */
    }
    <p>{`I don't know what it's doing. It's some sort of maths. But it runs good and strong with small inputs. It's easy to spin up and down. And doesn't keep anything in memory.`}</p>
    {
      /* /wp:paragraph */
    }
    {
      /* wp:paragraph */
    }
    <p>{`One wasn't enough so I'm running up to 10 in parallel 🔥`}</p>
    {
      /* /wp:paragraph */
    }
    {
      /* wp:heading */
    }
    <h2 {...{
      "id": "🥕"
    }}>{`🥕`}</h2>
    {
      /* /wp:heading */
    }
    {
      /* wp:paragraph */
    }
    <p>{`You can see `}<a parentName="p" {...{
        "href": "https://github.com/Swizec/thaw-carrots"
      }}>{`thaw-carrots on GitHub`}</a>{`. Install via npm.`}</p>
    {
      /* /wp:paragraph */
    }
    {
      /* wp:paragraph */
    }
    <p>{`Can't wait to try it at the office today. Nom!`}</p>
    {
      /* /wp:paragraph */
    }
    {
      /* wp:paragraph */
    }
    <p>{`Enjoy 🥕`}</p>
    {
      /* /wp:paragraph */
    }

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      